import { faCheck, faCopy, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { WithTooltip } from '../WithTooltip/WithTooltip';
import styles from './Copyable.module.scss';

const CopyableComponent = ({ text, overrideLabel = null }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }, [copied]);

  if (!text)
    return (
      <>
        <span className={'text-warning'}>
          <FontAwesomeIcon icon={faExclamationTriangle} />{' '}
        </span>
        <code>(null)</code>
      </>
    );
  return (
    <WithTooltip text={copied ? 'Copiato!' : 'Copia'} big={false}>
      <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
        <div className={`${styles.copyableWrapper} ${copied ? 'text-success' : ''}`}>
          <code className={styles.copyableCode}>{overrideLabel ?? text}</code>
          <FontAwesomeIcon icon={copied ? faCheck : faCopy} fixedWidth={true} />
        </div>
      </CopyToClipboard>
    </WithTooltip>
  );
};

export { CopyableComponent as Copyable };
